import {defaultPagination} from "@/services/pagination";
import {
  listBreadcrumps,
  listGroupmetadata,
  getGroupmetadata,
  exportSnapshot,
  restoreSnapshot
} from "@/services/api/app/office/recovery/team/data-set/metadata";
import {listInitialBackupStats} from "@/services/api/app/common/initialBackup";

const defaultState = () => ({
  files: [],
  searchFiles: [],
  searchPagination: {
    ...defaultPagination(),
    // sortBy: "snapshots.metadata_item.name",
    sortDescending: false
  },
  pagination: {
    ...defaultPagination(),
    // sortBy: "snapshots.metadata_item.name",
    sortDescending: false
  },
  folderId: null,
  breadcrumps: null,
  search: null,
  initialSearch: null,
  initialBackupStatus: {},
  filterBackupStatus: {
    provider: 1,
    module: 6,
    dataType: 14,
  },
  metadataDetails: {}
})

export default {
  namespaced: true,

  actions: {
    listFiles({commit, state}, data) {
      return listGroupmetadata({
        ...data,
        pagination: state.pagination,
        folderId: state.folderId,
        searchTerm: state?.search?.searchTerm
      })
        .then(({result, pagination}) => {
          let index = Date.parse(new Date());
          const res = result.map(file => {
            return {
              ...file,
              originalId: file.id,
              id: index++
            }
          })

          commit('setFiles', res)
          commit('setPagination', pagination)
        })
    },
    getDetails({commit, state}, data) {
      return getGroupmetadata(data)
        .then((result) => {
          commit('setDetails', result);
          return result;
        })
    },
    searchSnapshotDetails({commit, state}, data) {
      return listGroupmetadata(data)
        .then(({result, pagination}) => {
          commit('setSearchFiles', result)
          commit('setSearchPagination', pagination)
          return {result, pagination}
        })
    },
    listBreadcrumps({state, commit}, {teamId, snapshotDate}) {
      if (state.folderId && teamId && snapshotDate) {
        return listBreadcrumps({
          teamId,
          snapshotDate,
          folderId: state.folderId
        })
          .then(result => {
            commit('setBreadcrumps', result);
          })
      } else {
        commit('setBreadcrumps', []);
        return Promise.resolve();
      }
    },
    exportSnapshot({commit}, data) {
      console.log(data)
      return exportSnapshot(data);
    },
    restoreSnapshot({commit}, data) {
      return restoreSnapshot(data);
    },
    listInitialBackupStats({commit, state}, filter) {
      return listInitialBackupStats({
        ...state.filterBackupStatus,
        id: filter.id,
      })
        .then((result) => {
          commit('setInitialBackupStatus', result)
          return result;
        })
    },
  },

  mutations: {
    setFiles(state, files) {
      state.files = files;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setSearchFiles(state, files) {
      state.searchFiles = files;
    },
    setSearchPagination(state, pagination) {
      state.searchPagination = pagination;
    },
    resetSearchPagination(state) {
      state.searchPagination = {
        ...defaultPagination(),
        // sortBy: "snapshots.metadata_item.name",
        sortDescending: false
      };
    },
    setDetails(state, metadataDetails) {
      state.metadataDetails = metadataDetails;
    },
    setFolderId(state, folderId) {
      state.folderId = folderId;
    },
    setSearch(state, search) {
      state.search = search;
    },
    setBreadcrumps(state, breadcrumps) {
      state.breadcrumps = breadcrumps;
    },
    setInitialSearch(state, initialSearch) {
      state.initialSearch = initialSearch
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
    setInitialBackupStatus(state, initialBackupStatus) {
      state.initialBackupStatus = initialBackupStatus
    },
  },

  state: defaultState()
}
